import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { settingsKeys } from './settings.keys';
import { getSettings, updateChatbotSettings, updateMcpBotSettings, updateMemoryNotesSettings } from './settings.api';
export const useSettingsQuery = () => {
    return useQuery({
        queryKey: settingsKeys.all(),
        queryFn: () => getSettings()
    });
};
export const useUpdateChatbotSettingsMutation = () => {
    return useMutation({
        mutationFn: updateChatbotSettings,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: settingsKeys.all() }).then();
        }
    });
};
export const useUpdateMcpBotSettingsMutation = () => {
    return useMutation({
        mutationFn: updateMcpBotSettings,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: settingsKeys.all() }).then();
        }
    });
};
export const useUpdateMemoryNotesMutation = () => {
    return useMutation({
        mutationFn: updateMemoryNotesSettings,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: settingsKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=settings.query.js.map